"use client";

import NavLink from "next/link";
import { Button, Navbar as SpheronNav } from "@spheron/ui-library";
import SpheronLogo from "@spheron/ui-library/dist/assets/spheron-specific/spheron-logo.svg";
import Arrow from "@spheron/ui-library/dist/assets/arrow-right-1.svg";

// Fizz Node is being phased out — the navbar is intentionally stripped down to
// just the brand and a single call-to-action pointing users to Spheron GPUs.
const RENT_GPU_URL =
  "https://app.spheron.ai?utm_source=fizz-node&utm_medium=referral&utm_campaign=fizz-node-phase-out&utm_content=navbar-cta&ref=fizz-node";

const Navbar = () => {
  return (
    <SpheronNav
      logoIcon={
        <NavLink href="/">
          <div className="flex items-center justify-start gap-x-1 md:ml-0 -ml-2">
            <SpheronLogo className="w-10 h-10 text-logo-primary dark:text-dark-logo-primary" />
            <span className="text-base font-semibold md:block hidden">
              FIZZ NODE
            </span>
          </div>
        </NavLink>
      }
      navButtons={<></>}
      infoElements={
        <div className="flex items-center justify-end md:mr-0 -mr-2">
          <Button
            classname="w-max whitespace-nowrap"
            label="Rent GPUs on Spheron"
            size="small"
            buttonType="primary"
            rightIcon={<Arrow className="w-5 h-5" />}
            onClick={() => window.open(RENT_GPU_URL, "_blank")}
          />
        </div>
      }
    />
  );
};

export default Navbar;
